module.exports = __webpack_public_path__ + "static/media/distances.d317862b.svg";